import { formatAmplienceImageURL } from "@JohnLewisPartnership/jl-design-system/dist/utils/imageUrlModifier/imageUrlModifier";

import styles from "./KlarnaPlaceholder.module.scss";

const KLARNA_WORDMARK_URL =
  "https://static.johnlewiscontent.com/v1/static/Wordmark-Transparent-And-Black 2";
const KLARNA_LEARN_MORE_URL =
  "https://www.johnlewis.com/our-services/paymentplans/klarna";

export const KlarnaPlaceholder = () => {
  return (
    <div
      className={styles.container}
      data-component="KlarnaPlaceholder"
      data-testid="klarna-placeholder"
    >
      <span>
        Pay with{" "}
        <img
          src={formatAmplienceImageURL(KLARNA_WORDMARK_URL)}
          alt="Klarna"
          className={styles.logo}
        />
      </span>{" "}
      <a
        href={KLARNA_LEARN_MORE_URL}
        className={styles.learnMoreLink}
        aria-label="Learn more about Klarna"
      >
        Learn more
      </a>
    </div>
  );
};
